var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 512,
    viewBox: "0 0 640 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.6 160.4C314.4 160.1 317.2 160 320 160C373 160 416 202.1 416 256C416 309 373 352 320 352C266.1 352 224 309 224 256C224 253.2 224.1 250.4 224.4 247.6C233.7 252.1 244.5 256 256 256C291.3 256 320 227.3 320 192C320 180.5 316.1 169.7 311.6 160.4ZM512.6 112.6C559.4 156 590.7 207.1 605.5 243.7C608.8 251.6 608.8 260.4 605.5 268.3C590.7 304 559.4 355.1 512.6 399.4C465.5 443.2 400.8 480 320 480C239.2 480 174.5 443.2 127.42 399.4C80.6201 355.1 49.3401 304 34.4611 268.3C31.1796 260.4 31.1796 251.6 34.4611 243.7C49.3401 207.1 80.6201 156 127.42 112.6C174.5 68.84 239.2 32 320 32C400.8 32 465.5 68.84 512.6 112.6ZM320 112C240.5 112 176 176.5 176 256C176 335.5 240.5 400 320 400C399.5 400 464 335.5 464 256C464 176.5 399.5 112 320 112Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVisible);
export default __webpack_public_path__ + "static/media/ico_visible.1df23bdd21f7e09574dc7c1d74e33639.svg";
export { ForwardRef as ReactComponent };